import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import { Link } from 'react-router-dom';
import { appService } from '../../_services';
import { authHeader, config } from '../../_helpers'
import register from '../../registerServiceWorker';
import { de } from 'date-fns/locale';
import DocumentMeta from 'react-document-meta';


export class YourDetails extends Component {
    displayName = YourDetails.name
    constructor(props) {
        super(props);
        this.state = {
            key: '3',
            YourDetails: [],
            ReviewOrder: [],
            fields: {},
            errors: {}
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleCountriesChange = this.handleCountriesChange.bind(this);
        this.handleShippingCountriesChange = this.handleShippingCountriesChange.bind(this);
        this.handlegridRadios1Change = this.handlegridRadios1Change.bind(this);
        this.handlegridRadios2Change = this.handlegridRadios2Change.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handlegridRadios1Change(event) {
        var self = this;
        if (event.currentTarget.checked) {
            self.setState({
                sameAsBilling: "checked",
                NotsameAsBilling: "",
                shippingfirstname: '',
                shippinglastname: '',
                shippingcountryId: 0,
                shippingaddress1: '',
                shippingaddress2: '',
                shippingcity: '',
                shippingregionId: 0,
                shippingzip: '',
                shippingphoneNo: '',
            });

            document.getElementById('gridRadios1').checked;
            document.getElementById('dvShipping').style.display = "none";


        }

    }
    handlegridRadios2Change(event) {
        if (event.currentTarget.checked) {
            this.setState({
                sameAsBilling: "",
                NotsameAsBilling: "checked"
            });
            document.getElementById('dvShipping').style.display = "";
        }
    }

    handleChange(event) {

        let setvalue = '';
        if (event.target.type == "checkbox") {
            setvalue = event.target.checked
        }
        else {
            setvalue = event.target.value
        }
        var self = this;
        self.setState({ [event.target.id]: setvalue });
        let fields = self.state.fields;
        fields[event.target.id] = setvalue;
        self.setState({ fields });

    }

    handleCountriesChange(event) {
        var self = this;
        let fields = self.state.fields;
        fields[event.target.id] = event.target.value;
        self.setState({ [event.target.id]: event.target.value, fields });
        appService.getAll('Cart/GetByCountry?CountryId=' + event.target.value).then(function (response) {
            self.setState({
                regions: response,

            })
            if (response.length > 0) {
                self.state.regionId = response[0].id;
            }
            else {
                self.state.regionId = 0;
            }
        })
    }


    handleShippingCountriesChange(event) {
        var self = this;
        let fields = self.state.fields;
        fields[event.target.id] = event.target.value;
        self.setState({ [event.target.id]: event.target.value, fields });
        appService.getAll('Cart/GetByCountry?CountryId=' + event.target.value).then(function (response) {
            self.setState({
                shippingregions: response,

            })
            if (response.length > 0) {
                self.state.shippingregionId = response[0].id;
            }
            else {
                self.state.shippingregionId = 0;
            }
        })
    }



    handleSelect(Activekey) {


        if (Activekey == '1') {

            var self = this;
            appService.getAll('Cart/ShoppingCart').then(function (response) {
                self.setState({ CartItem: response });
            });

            document.getElementById('controlled-tab-example-tab-1').click();
        } 
    }


    handleSave(event) {

        event.preventDefault();
        var self = this;
        if (self.handleValidation()) {

            var countryCode = "";

            const requestOptionsCountry = {
                method: 'POST',
                headers: authHeader(),
                body: {},
            };

            let CountryId = self.state.shippingcountryId;
            if (CountryId <= 0) {
                CountryId = self.state.countryId;
            }
            
            appService.getAll('/Cart/GetCountryCodeById?CountryId=' + CountryId).then(function (response) {
                
                fetch("https://restcountries.eu/rest/v1/alpha/" + response.code)
                    .then(res => res.json())
                    .then(
                        (result) => {

                            let newcurrency = result.currencies[0];
                            self.state.newcurrency = newcurrency;
                           

                            YourDetails.firstname = self.state.firstname;

                            YourDetails.lastname = self.state.lastname;
                            YourDetails.organisation = self.state.organisation;
                            YourDetails.countryId = self.state.countryId;
                            YourDetails.countries = self.state.countries;
                            YourDetails.addressId = self.state.addressId;
                            YourDetails.address1 = self.state.address1;
                            YourDetails.address2 = self.state.address2;
                            YourDetails.city = self.state.city;
                            YourDetails.regionId = self.state.regionId;
                            YourDetails.regions = self.state.regions;
                            YourDetails.regionName = self.state.regionName;
                            YourDetails.zip = self.state.zip;
                            YourDetails.phoneNo = self.state.phoneNo;
                            YourDetails.vatnumber = self.state.vatnumber;
                            YourDetails.emailAddress = self.state.emailAddress;
                            YourDetails.saveForQuickCheckout = self.state.saveForQuickCheckout;
                            YourDetails.sendMeInfoOnProducts = self.state.sendMeInfoOnProducts;
                            //shipping address
                            YourDetails.shippingfirstname = self.state.shippingfirstname;
                            YourDetails.shippinglastname = self.state.shippinglastname;
                            // shippingorganisation= self.state.shippingOrganisation;
                            YourDetails.shippingcountryId = self.state.shippingcountryId;
                            YourDetails.shippingcountryName = self.state.shippingcountryName;
                            YourDetails.shippingcountries = self.state.shippingcountries;
                            YourDetails.shippingaddressId = self.state.shippingaddressId;
                            YourDetails.shippingaddress1 = self.state.shippingaddress1;
                            YourDetails.shippingaddress2 = self.state.shippingaddress2;
                            YourDetails.shippingcity = self.state.shippingcity;
                            YourDetails.shippingregionId = self.state.shippingregionId;
                            YourDetails.shippingregionName = self.state.shippingregionName;
                            YourDetails.shippingregions = self.state.shippingregions;
                            YourDetails.shippingzip = self.state.shippingzip;
                            YourDetails.shippingphoneNo = self.state.shippingphoneNo;
                            YourDetails.sameAsBilling = self.state.sameAsBilling;
                            //shippingvatnumber: response.shippingVatnumber,
                        });
                        
                // this.setState({ YourDetails: this.state.YourDetails });
                self.props.YourDetailsCallback(self.state);
                const requestOptions = {
                    method: 'POST',
                    headers: authHeader(),
                    body: JSON.stringify(self.state),
                    //cache: 'no-cache',
                };
                fetch(config.apiUrl + '/Cart/UpdateYourDetails', requestOptions).then(function (response) {
                        document.getElementById('controlled-tab-example-tab-3').click();
                    });
            }); 
    }
        else {
    return false;
}
    }

handleValidation() {
    var self = this;
    let fields = self.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!self.state.firstname) {
        formIsValid = false;
        errors["firstname"] = "Required field!";
    }

    if (self.state.firstname) {
        const re = /^[a-zA-Z]+[a-zA-Z]+$/;
        if (!re.test(self.state.firstname)) {
            formIsValid = false;
            errors["firstname"] = "Please enter valid first name!";
        }
    }


    if (!self.state.lastname) {
        formIsValid = false;
        errors["lastname"] = "Required field!";
    }

    if (self.state.lastname) {
        const re = /^[a-zA-Z]+[a-zA-Z]+$/;
        if (!re.test(self.state.lastname)) {
            formIsValid = false;
            errors["lastname"] = "Please enter valid last name!";
        }
    }


    if (!self.state.emailAddress) {
        formIsValid = false;
        errors["emailAddress"] = "Required field!";
    }

    if (self.state.vatnumber) {
        const re = /^[0-9a-zA-Z]+$/;
        if (!re.test(self.state.vatnumber)) {
            formIsValid = false;
            errors["vatnumber"] = "Please enter valid vat number!";
        }
    }

    if (!self.state.countryId) {
        formIsValid = false;
        errors["countryId"] = "Required field!";
    }
    


    if (self.state.emailAddress != "") {
        let lastAtPos = self.state.emailAddress.lastIndexOf('@');
        let lastDotPos = self.state.emailAddress.lastIndexOf('.');

        if (!(lastAtPos < lastDotPos && lastAtPos > 0 && self.state.emailAddress.indexOf('@@') == -1 && lastDotPos > 2 && (self.state.emailAddress.length - lastDotPos) > 2)) {
            formIsValid = false;
            errors["emailAddress"] = "Email is not valid";
        }
    }

    if (!self.state.address1) {
        formIsValid = false;
        errors["address1"] = "Required field!";
    }

    if (!self.state.city) {
        formIsValid = false;
        errors["city"] = "Required field!";
    }

    if (self.state.city) {
        const re = /^[a-zA-Z\s]*$/;
        if (!re.test(self.state.city)) {
            formIsValid = false;
            errors["city"] = "Please enter valid city!";
        }
    }

    if (!self.state.zip) {
        formIsValid = false;
        errors["zip"] = "Required field!";
    }

    if (self.state.zip) {
        var regeUK = /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/; //uk
        var regeUS = /^\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d$/; //us
        var regeNL = /^[0-9]{4}\s{0,1}[a-zA-Z]{2}$/; //nl
        var out = self.state.zip;
        if (!regeUK.test(out) && !regeUS.test(out) && !regeNL.test(out)) {
            formIsValid = false;
            errors["zip"] = "Please enter valid zip!";
        }
    }

    

    if (!self.state.phoneNo) {
        formIsValid = false;
        errors["phoneNo"] = "Required field!";
    } 

    if (self.state.phoneNo) {
        const re = /^[0-9*#+]+$/;
        if (!re.test(self.state.phoneNo)) {
            formIsValid = false;
            errors["phoneNo"] = "Please enter valid phoneno!";
        } 
    }

    //Shipping address Validation
    if (self.state.sameAsBilling != "checked") {
        if (!self.state.shippingfirstname) {
            formIsValid = false;
            errors["shippingfirstname"] = "Required field!";
        }

        if (self.state.shippingfirstname) {
            const re = /^[a-zA-Z]+[a-zA-Z]+$/;
            if (!re.test(self.state.shippingfirstname)) {
                formIsValid = false;
                errors["shippingfirstname"] = "Please enter valid first name!";
            }
        }

        if (!self.state.shippinglastname) {
            formIsValid = false;
            errors["shippinglastname"] = "Required field!";
        }

        if (self.state.shippinglastname) {
            const re = /^[a-zA-Z]+[a-zA-Z]+$/;
            if (!re.test(self.state.shippinglastname)) {
                formIsValid = false;
                errors["shippinglastname"] = "Please enter valid last name!";
            }
        }

        
        if (!self.state.shippingcountryId) {
            formIsValid = false;
            errors["shippingcountryId"] = "Required field!";
        }

        if (!self.state.shippingaddress1) {
            formIsValid = false;
            errors["shippingaddress1"] = "Required field!";
        }

        if (!self.state.shippingcity) {
            formIsValid = false;
            errors["shippingcity"] = "Required field!";
        }

        if (self.state.shippingcity) {
            const re = /^[a-zA-Z\s]*$/;
            if (!re.test(self.state.shippingcity)) {
                formIsValid = false;
                errors["shippingcity"] = "Please enter valid city!";
            }
        }

        if (!self.state.shippingzip) {
            formIsValid = false;
            errors["shippingzip"] = "Required field!";
        }

        if (self.state.shippingzip) {
            var regeUK = /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/; //uk
            var regeUS = /^\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d$/; //us
            var regeNL = /^[0-9]{4}\s{0,1}[a-zA-Z]{2}$/; //nl
            var out = self.state.shippingzip;
            if (!regeUK.test(out) && !regeUS.test(out) && !regeNL.test(out)) {
                formIsValid = false;
                errors["shippingzip"] = "Please enter valid zip!";
            }
        }

        if (!self.state.shippingphoneNo) {
            formIsValid = false;
            errors["shippingphoneNo"] = "Required field!";
        }

        if (self.state.shippingphoneNo) {
            const re = /^[0-9*#+]+$/;
            if (!re.test(self.state.shippingphoneNo)) {
                formIsValid = false;
                errors["shippingphoneNo"] = "Please enter valid phoneno!";
            }
        }
    }


    self.setState({ errors: errors });
    if (!formIsValid) {
        window.scrollTo({
            top: 200,
            behavior: 'smooth',
        });
        return false;
    }

    return true;
}
componentDidMount() {
    var self = this;
    if (self.props.YourDetails == undefined || self.props.YourDetails.length != undefined) {

        appService.getAll('Cart/GetSingleUserSubscriptionById').then(function (response) {

            self.setState({
                usersubscriptionid: response.usersubscriptionid,
                firstname: response.firstname,
                lastname: response.lastname,
                organisation: response.organisation,
                countryId: response.countryId,
                countries: response.countries,
                addressId: response.addressId,
                address1: response.address1,
                address2: response.address2,
                city: response.city,
                regionId: response.regionId,
                regions: response.regions,
                zip: response.zip,
                phoneNo: response.phoneNo,
                vatnumber: response.vatnumber,
                emailAddress: response.emailAddress,
                saveForQuickCheckout: response.saveForQuickCheckout,
                //shipping address
                shippingfirstname: response.shippingFirstname,
                shippinglastname: response.shippingLastname,
                // shippingorganisation: response.shippingOrganisation,
                shippingcountryId: response.shippingCountryId,
                shippingcountryName: response.shippingCountryName,
                shippingcountries: response.shippingcountries,
                shippingaddressId: response.shippingAddressId,
                shippingaddress1: response.shippingAddress1,
                shippingaddress2: response.shippingAddress2,
                shippingcity: response.shippingCity,
                shippingregionId: response.shippingRegionId,
                shippingregionName: response.shippingRegionName,
                shippingregions: response.shippingregions,
                shippingzip: response.shippingZip,
                shippingphoneNo: response.shippingPhoneNo,
                sameAsBilling: response.sameAsBilling,
                //shippingvatnumber: response.shippingVatnumber,
            });

            if (response.sameAsBilling == null || response.sameAsBilling == 'checked') {
                document.getElementById('gridRadios1').checked = true;
                document.getElementById('dvShipping').style.display = "none";
                self.setState({
                    sameAsBilling: "checked"
                });
            }
            else {
                document.getElementById('gridRadios2').checked = true;
                document.getElementById('dvShipping').style.display = "";
            }
        });
    }
    else {

        self.setState({
            firstname: self.props.YourDetails.firstname,
            lastname: self.props.YourDetails.lastname,
            organisation: self.props.YourDetails.organisation,
            countryId: self.props.YourDetails.countryId,
            countries: self.props.YourDetails.countries,
            addressId: self.props.YourDetails.addressId,
            address1: self.props.YourDetails.address1,
            address2: self.props.YourDetails.address2,
            city: self.props.YourDetails.city,
            regionId: self.props.YourDetails.regionId,
            regions: self.props.YourDetails.regions,
            zip: self.props.YourDetails.zip,
            phoneNo: self.props.YourDetails.phoneNo,
            vatnumber: self.props.YourDetails.vatnumber,
            emailAddress: self.props.YourDetails.emailAddress,
            saveForQuickCheckout: self.props.YourDetails.saveForQuickCheckout,
            sendMeInfoOnProducts: self.props.YourDetails.sendMeInfoOnProducts,
            //shipping address
            shippingfirstname: self.props.YourDetails.shippingfirstname,
            shippinglastname: self.props.YourDetails.shippinglastname,
            // shippingorganisation: self.props.YourDetails.shippingOrganisation,
            shippingcountryId: self.props.YourDetails.shippingcountryId,
            shippingcountryName: self.props.YourDetails.shippingcountryName,
            shippingcountries: self.props.YourDetails.shippingcountries,
            shippingaddressId: self.props.YourDetails.shippingaddressId,
            shippingaddress1: self.props.YourDetails.shippingaddress1,
            shippingaddress2: self.props.YourDetails.shippingaddress2,
            shippingcity: self.props.YourDetails.shippingcity,
            shippingregionId: self.props.YourDetails.shippingregionId,
            shippingregionName: self.props.YourDetails.shippingregionName,
            shippingregions: self.props.YourDetails.shippingregions,
            shippingzip: self.props.YourDetails.shippingzip,
            shippingphoneNo: self.props.YourDetails.shippingphoneNo,
            sameAsBilling: self.props.YourDetails.sameAsBilling,
        });

        if (self.props.YourDetails.sameAsBilling == null || self.props.YourDetails.sameAsBilling == 'checked') {
            document.getElementById('gridRadios1').checked = true;
            document.getElementById('dvShipping').style.display = "none";
            self.state.sameAsBilling = "checked";
        }
        else {
            document.getElementById('gridRadios2').checked = true;
            document.getElementById('dvShipping').style.display = "";
        }
    }
}

render() {
    const meta = {
        title: "Kluwer Law Online - Your details",
        //description: "Kluwer Law Online publishes peer-reviewed journals and manuals on various practice areas in international law. Browse within our practice areas to discover which titles we offer in your area of legal practice or on important legal subject-matters.",
        canonical: window.location.href,
        meta: {
            charset: "utf-8",
            name: {
                keywords: "Shopping cart,Online Shopping,Manuals,practice area in international law,corporate and commercial law, litigation, labour law and transport law"
            }
        }
    }
    return (
        <DocumentMeta {...meta}>
        <form name="yourdetailsform" onSubmit={this.handleSave}>
            <div >

                    <p className="franziskafont">Your details</p>
                <div className="row">
                    <div className="col mr-4">

                        <h6 className="my-3 green-heading">Billing address</h6>
                        <br></br>
                        <div className="form-row mt-3">
                            <div className="col">
                                <label htmlFor="firstName">First name</label>

                                <input type="text" className="form-control form-control-sm rounded-0" id="firstname" value={this.state.firstname} onChange={this.handleChange} placeholder="First name" />
                                <span className="error">{this.state.errors["firstname"]}</span>
                            </div>
                            <div className="col">
                                <label htmlFor="lastName">Last name</label>
                                <input type="text" className="form-control form-control-sm rounded-0" id="lastname" value={this.state.lastname} onChange={this.handleChange} placeholder="Last name" />
                                <span className="error">{this.state.errors["lastname"]}</span>
                            </div>
                        </div>
                        <br></br>
                        <div className="form-row mt-3">
                            <div className="col-6">
                                <label htmlFor="organization">Organization  (optional)</label>
                                <input type="text" className="form-control form-control-sm rounded-0" id="organisation" value={this.state.organisation} onChange={this.handleChange} placeholder="Organization" />
                            </div>
                            <div className="col">
                                <label htmlFor="vatNumber">VAT number  (if applicable)</label>
                                <input type="text" className="form-control form-control-sm rounded-0" id="vatnumber" value={this.state.vatnumber} onChange={this.handleChange} placeholder="VAT number" />
                                <span className="error">{this.state.errors["vatnumber"]}</span>
                            </div>
                        </div>
                        <br></br>
                        <div className="form-group mt-3">
                            <label htmlFor="exampleFormControlSelect1">Country</label>


                            <select className="form-control form-control-sm rounded-0" id="countryId" value={this.state.countryId} onChange={this.handleCountriesChange}>
                                    <option selected style={{display:'none'}}> </option>
                                    {
                                    (this.state.countries && this.state.countries.length > 0) && this.state.countries.map((data) => {
                                        return (<option value={data.id}> {data.country}</option>);
                                    })
                                }
                            </select>
                                <span className="error">{this.state.errors["countryId"]}</span>
                        </div>
                        <br></br>
                        <div className="form-group mt-3">
                            <label htmlFor="AddressOne">Address 1</label>
                            <input type="text" className="form-control form-control-sm rounded-0" id="address1" value={this.state.address1} onChange={this.handleChange} placeholder="Address 1" />
                            <span className="error">{this.state.errors["address1"]}</span>
                        </div>
                        <br></br>
                        <div className="form-group mt-3">
                            <label htmlFor="AddressTwo">Address 2  (optional)</label>
                            <input type="text" className="form-control form-control-sm rounded-0" id="address2" value={this.state.address2} onChange={this.handleChange} placeholder="Address 2" />
                        </div>
                        <br></br>
                        <div className="form-row mt-3">
                            <div className="col">
                                <label htmlFor="city">City</label>
                                <input type="text" className="form-control form-control-sm rounded-0" id="city" value={this.state.city} onChange={this.handleChange} placeholder="City" />
                                <span className="error">{this.state.errors["city"]}</span>
                            </div>
                            <div className="col">
                                <label htmlFor="organization">Region</label>



                                <select className="form-control form-control-sm rounded-0" id="regionId" value={this.state.regionId} onChange={this.handleChange}>
                                    {
                                        (this.state.regions && this.state.regions.length > 0) && this.state.regions.map((data) => {
                                            return (<option value={data.id}> {data.region}</option>);
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col">
                                <label htmlFor="vatNumber">Zip/Postal code</label>
                                <input type="text" className="form-control form-control-sm rounded-0" id="zip" value={this.state.zip} onChange={this.handleChange} placeholder="Zip/Postal code" />
                                <span className="error">{this.state.errors["zip"]}</span>
                            </div>
                        </div>
                        <br></br>
                        <div className="form-group mt-3">
                            <label htmlFor="phoneNumber">Phone number</label>
                                <input type="text" className="form-control form-control-sm rounded-0" id="phoneNo" value={this.state.phoneNo} onChange={this.handleChange} placeholder="Phone number" minlength="8" />
                            <span className="error">{this.state.errors["phoneNo"]}</span>
                        </div>
                        <br></br>

                    </div>
                    <div className="col-0 border-right" > </div>
                    <div className="col ml-3">

                        <h6 className="my-3 green-heading">Email address (confirmations/access details will be sent here)</h6>
                        <br></br>
                        <div className="form-group">
                            <label htmlFor="exampleFormControlInput1">Email address</label>
                            <input type="email" className="form-control form-control-sm rounded-0" id="emailAddress" value={this.state.emailAddress} onChange={this.handleChange} placeholder="Email" />
                            <span className="error">{this.state.errors["emailAddress"]}</span>
                        </div>
                        <br></br>
                        <hr className="mt-4 mb-3" />
                        <fieldset className="form-group">
                            <h6 className="my-3">Shipping address</h6> <br></br>
                            <div className="col row">
                                <div className="custom-control custom-radio col">
                                    <input className="custom-control-input" type="radio" name="gridRadios" onChange={this.handlegridRadios1Change} id="gridRadios1" placeholder="option1" checked={this.state.sameAsBilling} />
                                    <label className="custom-control-label" htmlFor="gridRadios1">Same as billing address
                                                    </label>
                                </div>
                                <div className="custom-control custom-radio col">
                                    <input className="custom-control-input" type="radio" name="gridRadios" onChange={this.handlegridRadios2Change} id="gridRadios2" placeholder="option2" checked={this.state.NotsameAsBilling} />
                                    <label className="custom-control-label" htmlFor="gridRadios2">Ship to a different address
                                             </label>
                                </div>
                            </div>
                        </fieldset>
                        <hr className="mt-4 mb-3" />

                        <div id="dvShipping">

                            <div className="form-row mt-3">
                                <h6 className="my-3 green-heading">Shipping Address</h6>
                            </div>
                            <br></br>


                            <div className="form-row mt-3">
                                <div className="col">
                                    <label htmlFor="shippingfirstname">First name</label>

                                    <input type="text" className="form-control form-control-sm rounded-0" id="shippingfirstname" value={this.state.shippingfirstname} onChange={this.handleChange} placeholder="First name" />
                                    <span className="error">{this.state.errors["shippingfirstname"]}</span>
                                </div>
                                <div className="col">
                                    <label htmlFor="shippinglastname">Last name</label>
                                    <input type="text" className="form-control form-control-sm rounded-0" id="shippinglastname" value={this.state.shippinglastname} onChange={this.handleChange} placeholder="Last name" />
                                    <span className="error">{this.state.errors["shippinglastname"]}</span>
                                </div>
                            </div>

                            {/*   <div className="form-row mt-3">
                                <div className="col-6">
                                    <label htmlFor="shippingorganisation">Organization(optional)</label>
                                    <input type="text" className="form-control form-control-sm rounded-0" id="shippingorganisation" value={this.state.shippingorganisation} onChange={this.handleChange} placeholder="Organization" />
                                </div>
                                <div className="col">
                                    <label htmlFor="shippingvatnumber">VAT number(if applicable)</label>
                                    <input type="text" className="form-control form-control-sm rounded-0" id="shippingvatnumber" value={this.state.shippingvatnumber} onChange={this.handleChange} placeholder="VAT number" />
                                </div>
                                </div>*/}

                            <div className="form-row mt-3">
                                <div className="col-6">
                                    <label htmlFor="shippingcountries">Country</label>
                                    <select className="form-control form-control-sm rounded-0" id="shippingcountryId" value={this.state.shippingcountryId} onChange={this.handleShippingCountriesChange}>
                                            <option selected style={{ display: 'none' }}> </option>
                                            {
                                            (this.state.shippingcountries && this.state.shippingcountries.length > 0) && this.state.shippingcountries.map((data) => {
                                                return (<option value={data.id}> {data.country}</option>);
                                            })
                                        }
                                        </select>
                                        <span className="error">{this.state.errors["shippingcountryId"]}</span>
                                </div>
                                <div className="col">
                                    <label htmlFor="shippingAddressOne">Address 1</label>
                                    <input type="text" className="form-control form-control-sm rounded-0" id="shippingaddress1" value={this.state.shippingaddress1} onChange={this.handleChange} placeholder="Address 1" />
                                    <span className="error">{this.state.errors["shippingaddress1"]}</span>
                                </div>
                            </div>

                            <div className="form-row mt-3">
                                <div className="col-6">
                                    <label htmlFor="shippingAddressTwo">Address 2  (optional)</label>
                                    <input type="text" className="form-control form-control-sm rounded-0" id="shippingaddress2" value={this.state.shippingaddress2} onChange={this.handleChange} placeholder="Address 2" />
                                </div>
                                <div className="col">
                                    <label htmlFor="shippingcity">City</label>
                                    <input type="text" className="form-control form-control-sm rounded-0" id="shippingcity" value={this.state.shippingcity} onChange={this.handleChange} placeholder="City" />
                                    <span className="error">{this.state.errors["shippingcity"]}</span>
                                </div>
                            </div>

                            <div className="form-row mt-3">
                                <div className="col-6">
                                    <label htmlFor="shippingAddressTwo">Region</label>
                                    <select className="form-control form-control-sm rounded-0" id="shippingregionId" value={this.state.shippingregionId} onChange={this.handleChange}>
                                            <option selected style={{ display: 'none' }}> </option>
                                            {
                                            (this.state.shippingregions && this.state.shippingregions.length > 0) && this.state.shippingregions.map((data) => {
                                                return (<option value={data.id}> {data.region}</option>);
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col">
                                    <label htmlFor="shippingzip">Zip/Postal code</label>
                                    <input type="text" className="form-control form-control-sm rounded-0" id="shippingzip" value={this.state.shippingzip} onChange={this.handleChange} placeholder="Zip/Postal code" />
                                    <span className="error">{this.state.errors["shippingzip"]}</span>
                                </div>
                            </div>


                            <div className="form-row mt-3">
                                <div className="col-6">
                                    <label htmlFor="shippingphoneNo">Phone number</label>
                                        <input type="text" className="form-control form-control-sm rounded-0" id="shippingphoneNo" value={this.state.shippingphoneNo} onChange={this.handleChange} placeholder="Phone number" minlength="8" />
                                    <span className="error">{this.state.errors["shippingphoneNo"]}</span>
                                </div>
                                <div className="col">

                                </div>
                            </div>

                        </div>







                        <br></br>
                        <div className="form-group">
                            <div className="square"><input id="saveForQuickCheckout" checked={this.state.saveForQuickCheckout} type="checkbox" onChange={this.handleChange} />
                                <label htmlFor="saveForQuickCheckout"></label>
                                <span className="SpanSaveAll">Save all details for quicker checkout next time.</span>
                            </div>

                        </div>
                        <div className="form-group">
                                <div className="square"><input type="checkbox" id="sendMeInfoOnProducts" checked={this.state.sendMeInfoOnProducts} type="checkbox" onChange={this.handleChange} />
                                <label htmlFor="sendMeInfoOnProducts"></label>
                                <span className="SpanSaveAll">Yes, send me information on similar products and content from Wolters Kluwer.</span>
                            </div>

                        </div>

                        <br></br>

                        <div className="form-group">
                                <div className="square"><input type="checkbox" id="SendConsent" />
                                <label htmlFor="SendConsent"></label>
                                <span className="SpanSaveAll">I consent to the collection of my personal information by Kluwer Law International, so that i can create an account to store my contact information and order history to facilitate ecommerce transactions. I understand that my personal information will be processed for this purpose.</span>
                            </div>

                        </div>
                        <div className="">
                                <p>For more information about our privacy policy,  <a className="LinkClass" href="http://www.kluwerlaw.com/gdpr/">Click Here</a>.</p>
                        </div>
                    </div>
                </div>


            </div>

            <div className="row mb-5 mt-3 ">
                <div className="col">
                    <button type="button" className="btn float-left back-btn rounded-0" onClick={() => this.handleSelect("1")}>Back</button>
                </div>
                <div className="col">
                    <button type="submit" eventKey={3} className="btn float-left next float-right rounded-0">Review your order</button>


                </div>
            </div>

        </form>
        </DocumentMeta>
    );
}
}

export default YourDetails;



// WEBPACK FOOTER //
// ./src/components/Shopping Cart/YourDetails.jsx